import { Info, AlertTriangle, CheckCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface FeedbackMessageProps {
  type: 'suggestion' | 'warning' | 'praise' | 'none'
  message: string
}

export function FeedbackMessage({ type, message }: FeedbackMessageProps) {
  const { t } = useTranslation();
  
  const styles = {
    suggestion: 'bg-[#e8f1fd]',
    warning: 'bg-[#fff4eb]',
    praise: 'bg-[#e7fef7]'
  }

  const Icon = {
    suggestion: Info,
    warning: AlertTriangle,
    praise: CheckCircle
  }[type]

  const labelColors = {
    suggestion: 'text-[#0072ff]',
    warning: 'text-[#e56b00]',
    praise: 'text-[#069e71]'
  }
  
  const typeLabels = {
    suggestion: t('feedback.transcript.suggestion', 'Suggestion'),
    warning: t('feedback.transcript.warning', 'Warning'),
    praise: t('feedback.transcript.praise', 'Praise')
  }

  return (
    <div className={`flex items-start gap-3 p-4 rounded-lg ${styles[type]}`}>
      <Icon className={`h-5 w-5 mt-0.5 ${labelColors[type]}`} />
      <p className="text-[#1a1817]">
        <span className={`font-semibold ${labelColors[type]}`}>
          {typeLabels[type]}: 
        </span>{' '}
        {message}
      </p>
    </div>
  )
}

